import { CSSProperties, FC, useEffect, useState } from 'react';
import styles from './UserAvatar.module.scss';

interface UserAvatarProps {
    src?: string | null;
    name?: string | null;
    email?: string | null;
    alt?: string;
    fontSize?: CSSProperties['fontSize'];
}

const getInitials = (name?: string | null, email?: string | null) => {
    const label = name?.trim() || email?.split('@')[0].replace(/[._+-]+/g, ' ').trim() || '';
    const parts = label.split(/\s+/).filter(Boolean);

    if (parts.length > 1) {
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }

    return parts[0]?.slice(0, 2).toUpperCase() || '?';
};

const UserAvatar: FC<UserAvatarProps> = ({ src, name, email, alt = 'User avatar', fontSize = 14 }) => {
    const [imageFailed, setImageFailed] = useState(false);

    useEffect(() => {
        setImageFailed(false);
    }, [src]);

    if (src && !imageFailed) {
        return <img src={src} alt={alt} className={styles.image} onError={() => setImageFailed(true)} />;
    }

    return (
        <div role="img" aria-label={alt} className={styles.avatar} style={{ fontSize }}>
            {getInitials(name, email)}
        </div>
    );
};

export default UserAvatar;
